import olBingMaps from './../../node_modules/ol/source/BingMaps.js';

class BingMaps extends olBingMaps {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

export default BingMaps;